import DomParser from 'dom-parser';

// Set lookup rather than Array.includes inside a loop.
function findNewIds(initialIds, currentIds) {
    const known = new Set(initialIds);
    return currentIds.filter((id) => !known.has(id));
}

// Collect every id under an element, so the two documents can be compared.
const collectIds = (element, into) => {
    const idAttr = element.getAttribute('id');
    if (idAttr) into.add(idAttr);

    element.childNodes.forEach((childNode) => {
        if (childNode.nodeType === Node.ELEMENT_NODE) collectIds(childNode, into);
    });
};

// Strips nodes the editor injected into the preview - its style tag, the picker
// overlays - so they never reach the saved file. Compares the live iframe
// against the pristine copy of the file and removes what is new.
//
// There used to be a second pass over class names too. It read the bare
// `document` rather than the iframe's, so it could not touch page content and
// instead deleted the editor's own React nodes whenever the page happened to use
// a class name the editor also uses - the blank-screen crash. It is gone rather
// than repointed, because scoped correctly it would delete the element being
// edited: the editor tags that one with `tiinyedit`/`tiinyeditabletext` at
// runtime, and "carries a class the original did not" is equally true of any
// element the page's own scripts touch. Removing a node is the wrong answer to
// an unwanted class anyway - cleanHtmlForPublish strips those names from the
// saved markup and resetEditableElements clears them from the DOM.
function removeUnwantedNodes(htmlString, iframeDocument){
    // No pristine copy to compare against - a fetch that failed, or a file that
    // was never HTML. There is nothing to decide here, and the parser throws on
    // a missing string, which used to abort the caller before it could save.
    if (!htmlString) return;

    const parser = new DomParser();
    const initialDom = parser.parseFromString(htmlString);
    const currentDom = parser.parseFromString(iframeDocument.documentElement.outerHTML);

    const initialBody = initialDom.getElementsByTagName('body');
    const currentBody = currentDom.getElementsByTagName('body');
    if (!initialBody[0] || !currentBody[0]) return;

    const initialIds = new Set();
    const currentIds = new Set();
    collectIds(initialBody[0], initialIds);
    collectIds(currentBody[0], currentIds);

    findNewIds(Array.from(initialIds), Array.from(currentIds)).forEach((newId) => {
        const nodeToRemove = iframeDocument.getElementById(`${newId}`);
        if (nodeToRemove && nodeToRemove.parentNode) {
            nodeToRemove.parentNode.removeChild(nodeToRemove);
        }
    });
}

export default removeUnwantedNodes;
